export enum ROLES {
    Administrador = '1', 
    SuperUsuario = '2', 
    GerenteCuenta = '4'
}